export const actionTypes = {
    SET_BAR_CHART_DATA: 'SET_BAR_CHART_DATA',
    SET_BAR_CHART_CANCEL_TOKEN: 'SET_BAR_CHART_CANCEL_TOKEN',
    IS_BAR_CHART_FETCHING: 'IS_BAR_CHART_FETCHING'
}